// Dispara o download de um arquivo recebido do backend.
export function baixarArquivo(arquivo: Blob, nomeArquivo: string): void {
  const url = URL.createObjectURL(arquivo);
  const link = document.createElement('a');
  link.href = url;
  link.download = nomeArquivo;
  link.click();
  URL.revokeObjectURL(url);
}
